import React from 'react'
import { observable } from "mobx";
import _ from 'lodash';
import CargaPatioDTCService from "../../../../services/CargaPatioDTCService";

export default class CargaPatioDTCStore {

    constructor() {
        this.service = new CargaPatioDTCService()
    }

    obterOperacoes(){
      return this.service.obterOperacoes();
    }

    obterDespachantes(){
      return this.service.obterDespachantes();
    }

    salvarSolicitacao(solicitacao){
      return this.service.salvarSolicitacao(solicitacao);
    }

    alterarSolicitacao(solicitacao){
      return this.service.alterarSolicitacao(solicitacao);
    }

    obterSolicitacao(id){
      return this.service.obterSolicitacao(id);
    }

    filtrarSolicitacoes(operacao, container, tipoPedido){
      return this.service.filtrarSolicitacoes(operacao, container, tipoPedido);
    }

    invalidarSolicitacao(id){
      return this.service.invalidarSolicitacao(id);
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/cargapatiodtc/stores/CargaPatioDTCStore.js